<template>
  <el-radio-group v-model="state.value" @change="onChange">
    <el-radio-button>全部</el-radio-button>
    <el-radio-button
      v-for="item in state.arr_data"
      :key="item"
      :value="item.Key"
    >
      <text
        :style="{
          color: state.value == item.Key ? '#fff' : item.Color,
        }"
        v-if="props.color"
      >
        {{ item.Text }}
      </text>
      <text v-else>{{ item.Text }}</text>
    </el-radio-button>
  </el-radio-group>
</template>

<script>
import { onMounted, reactive } from "vue";
import constant from "@/utils/constant";
export default {
  props: {
    arrName: String, //状态数组名称
    value: Object, //值
    //是否显示全部
    all: {
      type: Boolean,
      default: true,
    },
    //是否显示颜色
    color: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      state.value = props.value;
      state.arr_data = constant[props.arrName];
    });

    const onChange = (e) => {
      emit("update:modelValue", e);
    };
    return { state, props, onChange };
  },
};
</script>
<style scoped></style>
